// extracted by mini-css-extract-plugin
export var logo = "_4n-2";
export var logoWrapper = "_4n-1";
export var strip = "_4n-0";